import React, { useState, useEffect } from 'react';
import { useUser } from '../../firebase_service/UserContext';
import { db } from '../../firebase_service/firebase';
import { doc, getDoc, updateDoc, Timestamp } from 'firebase/firestore';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../../css/components/Dashboard.css';

const get_start_end_date = () => {
  const now = Timestamp.now();
  const jsDate = now.toDate();
  const year = jsDate.getFullYear();
  const month = jsDate.getMonth();
  const start_date = Timestamp.fromDate(new Date(year, month, 1, 0, 0, 0));
  const lastDay = new Date(year, month + 1, 0).getDate();
  const end_date = Timestamp.fromDate(new Date(year, month, lastDay, 23, 59, 59));
  return { start_date, end_date };
};


const Dashboard = () => {
  const { user } = useUser();
  const [planDetails, setPlanDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentplan,setCurrentplan]=useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userRef);
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            
            if (userData.plan_details) {
              const currentPlan = userData.plan_details.plan;
              const endDate = userData.plan_details.end_date;

              setCurrentplan(currentPlan);
              
              if ((currentPlan === 'FREE' || currentPlan === 'PRO' || currentPlan === 'PRO+') && 
                  endDate <= Timestamp.now()) {
                const { start_date, end_date } = get_start_end_date();
                
                await updateDoc(userRef, {
                  'plan_details.plan': 'FREE',
                  'plan_details.start_date': start_date,
                  'plan_details.end_date': end_date,
                  'plan_details.remaining_prompts': 20
                });
                
                setPlanDetails({
                  ...userData.plan_details,
                  isFreeCreditDone: false,
                  plan: 'FREE',
                  start_date,
                  end_date,
                  remaining_prompts: 20
                });
              } else {
                setPlanDetails(userData.plan_details);
              }
            }
          }
          setLoading(false);
        } catch (error) {
         
          setLoading(false);
        }
      }
    };

    fetchUserData();
  }, [user]);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <Header />
      <main className="dashboard-container">
        <div className="dashboard-header">
          <h1>Welcome back, {user?.displayName}! <span className="wave">👋</span></h1>
          <p>Monitor your account activity and subscription status</p>
        </div>

        <div className="dashboard-grid">
          <div className="dashboard-card user-info">
            <h2><span className="icon">👤</span> Profile Information</h2>
            <div className="user-details">
              <div className="user-avatar">
                {user?.photoURL ? (
                  <img src={user.photoURL} alt="Profile" />
                ) : (
                  <div className="avatar-placeholder">{user?.displayName?.[0]}</div>
                )}
              </div>
              <div className="user-info-details">
                <p><strong>Name:</strong> {user?.displayName}</p>
                <p><strong>Email:</strong> {user?.email}</p>
                <p><strong>Member since:</strong> {new Date(user?.metadata?.creationTime).toLocaleDateString()}</p>
              </div>
            </div>
          </div>

          <div className="dashboard-card subscription-info">
            <h2><span className="icon">✨</span> Subscription Details</h2>
            {planDetails ? (
              <div className="plan-details">
                <div className="plan-header">
                  <span className="plan-badge">{planDetails.plan}</span>
                  <span className="prompts-remaining">
                    <span className="icon">🎯</span>
                    {(currentplan=="PRO+")?"unlimited prompts":`${planDetails.remaining_prompts} prompts left`}
                  </span>
                </div>
                <div className="plan-dates">
                  <p><strong>Start Date:</strong> {planDetails.start_date?.toDate().toLocaleDateString()}</p>
                  <p><strong>End Date:</strong> {planDetails.end_date?.toDate().toLocaleDateString()}</p>
                </div>
                <div className="usage-bar">
                  <div 
                    className="usage-progress" 
                    style={{ width: `${(planDetails.remaining_prompts / 100) * 100}%` }}
                  ></div>
                </div>
              </div>
            ) : (
              <p>No subscription details available</p>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Dashboard;